/* tslint:disable */
/* eslint-disable */
/**
 * Limber Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PromisScores
 */
export interface PromisScores {
    /**
     * 
     * @type {number}
     * @memberof PromisScores
     */
    painInterference: number;
    /**
     * 
     * @type {number}
     * @memberof PromisScores
     */
    physicalFunction?: number;
    /**
     * 
     * @type {number}
     * @memberof PromisScores
     */
    upperExtremityPhysicalFunction?: number;
}

export function PromisScoresFromJSON(json: any): PromisScores {
    return PromisScoresFromJSONTyped(json, false);
}

export function PromisScoresFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromisScores {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'painInterference': json['pain-interference'],
        'physicalFunction': !exists(json, 'physical-function') ? undefined : json['physical-function'],
        'upperExtremityPhysicalFunction': !exists(json, 'upper-extremity-physical-function') ? undefined : json['upper-extremity-physical-function'],
    };
}

export function PromisScoresToJSON(value?: PromisScores | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pain-interference': value.painInterference,
        'physical-function': value.physicalFunction,
        'upper-extremity-physical-function': value.upperExtremityPhysicalFunction,
    };
}


